import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import store from './store'
import router from './router'
import VueCookies from 'vue-cookies'
import rest from '@/plugins/rest'

Vue.use(VueCookies);

Vue.config.productionTip = false;


new Vue({
  store,
  router,
  render: h => h(App),
  created: function () {
    const self = this;

    // When the VUE instance gets created we check if there is a tokenId.
    // If it is there we validate it gainst the backend and init session if its valid.
    let idToken = this.$cookies.get("idToken");

    if (idToken) {

      rest.auth(idToken).then(data => {
        if (data.valid) {
          // Store this idToken for further requests.
          data.idToken = idToken;
          self.$store.dispatch('setCurrentUser', data);
          rest.setIdToken(idToken);
        }
        else {
          console.log(data);
        }
      })

    }


  }
}).$mount('#app');
